const substitutions = [
  {
    heading: 'Помоги мне решить уравнение',
    substitude: '*уравнение*'
  },
  {
    heading: 'Как правильно посчитать',
    substitude: 'атомы в элементе *элемент*'
  },
  {
    heading: 'Найди площадь треугольника,',
    substitude: 'со сторонами *стороны*'
  },
  {
    heading: 'Напиши сочинение на 100 слов',
    substitude: 'на тему *тема сочинения*'
  },
  {
    heading: 'Сравни двух персонажей',
    substitude: 'произведения *произведение*'
  },
]

export default substitutions